import { useQuery } from "@tanstack/react-query"
import { routes, submissionProgressSchema } from "@nova-ai/shared"

import { apiFetch } from "../lib/api"
import { queryKeys } from "./query-keys"

/** Poll durable evidence. This read never owns marketplace execution. */
export function useRunSubmission(slug: string, historyOffset = 0) {
  return useQuery({
    queryKey: queryKeys.runSubmission(slug, historyOffset),
    enabled: Boolean(slug),
    placeholderData: (previous, query) => (query?.queryKey[1] === slug ? previous : undefined),
    refetchInterval: 10_000,
    refetchOnMount: "always",
    queryFn: async () => {
      const result = await apiFetch<unknown>(
        `${routes.runs.submission({ slug })}?historyOffset=${historyOffset}`
      )
      if (!result.ok) {
        throw new Error(result.error.message)
      }
      return submissionProgressSchema.parse(result.value)
    },
  })
}
